export enum ELapadaFormTypes {
  REQUIRED = 'required',
  DETAILS = 'details',
  DESCRIPTIONS = 'descriptions',
  META = 'meta',
  IMAGE = 'image'
}
